<template>
    <v-row justify="center">

      <v-col v-if="!dense" cols="12" class="text-left">
        <h3 class="">{{ $t('delivery.orderPayment') }} </h3>
      </v-col>


      <template v-if="getPaymentMethods">
        <v-col cols="12">
          <v-card >
            <v-card-title v-if="dense" class="pb-0 pt-2">
              Método de Pago <span class="red--text">*</span>
            </v-card-title>

            <v-radio-group dense v-model="localValue" class="mt-0">
              <!--CASH-->
              <template v-if="getPaymentMethods && (!onlyEnable || getPaymentMethods.cash.enable) && getPaymentMethods.cash.modes.includes(orderDeliveryMode)">
                <v-card-text>
                  <v-radio :value="getPaymentMethods.cash.identifier" label="Efectivo"></v-radio>
                </v-card-text>
              </template>

              <!--DEBIT-->
              <template v-if="getPaymentMethods && (!onlyEnable || getPaymentMethods.debit.enable) && getPaymentMethods.debit.modes.includes(orderDeliveryMode)">
                <v-divider></v-divider>
                <v-card-text>
                  <v-radio :value="getPaymentMethods.debit.identifier" label="Débito"></v-radio>
                </v-card-text>
              </template>

              <!--BANK_TRANSFER-->
              <template v-if="getPaymentMethods && (!onlyEnable || getPaymentMethods.bankTransfer.enable) && getPaymentMethods.bankTransfer.modes.includes(orderDeliveryMode)">
                <v-divider></v-divider>
                <v-card-text>
                  <v-radio :value="getPaymentMethods.bankTransfer.identifier" label="Transferencia Bancaria"></v-radio>
                  <v-alert
                      v-if="localValue === getPaymentMethods.bankTransfer.identifier && getPaymentMethods.bankTransfer.info "
                      type="info"
                  >
                    {{ getPaymentMethods.bankTransfer.info }}
                  </v-alert>
                </v-card-text>
              </template>

              <!--MP_TRANSFER-->
              <template v-if="getPaymentMethods && (!onlyEnable || getPaymentMethods.mercadoPagoTransfer.enable) && getPaymentMethods.mercadoPagoTransfer.modes.includes(orderDeliveryMode)">
                <v-divider></v-divider>
                <v-card-text>
                  <v-radio :value="getPaymentMethods.mercadoPagoTransfer.identifier"
                           label="Transferencia Mercado Pago"></v-radio>
                  <v-alert
                      v-if="localValue === getPaymentMethods.mercadoPagoTransfer.identifier && getPaymentMethods.mercadoPagoTransfer.info "
                      type="info"
                  >
                    {{ getPaymentMethods.mercadoPagoTransfer.info }}
                  </v-alert>
                </v-card-text>
              </template>

            </v-radio-group>

          </v-card>
        </v-col>

        <v-col v-if="submitButton" cols="12" class="text-right">
          <submit-button
              :text="submitText"
              @click="$emit('confirm')"
              :disabled="!this.localValue"
          ></submit-button>
        </v-col>

      </template>

      <v-col v-else cols="12" class="px-6">
        <loading></loading>
      </v-col>


    </v-row>
</template>

<script>
import {Loading, SubmitButton} from "@dracul/common-frontend"

export default {
  name: "PaymentMethod",
  components: {Loading, SubmitButton},
  props: {
    dense: {type: Boolean, default: false},
    onlyEnable: {type: Boolean, default: true},
    submitButton: {type: Boolean, default: false},
    submitText: {type: String, default: 'common.next'},
  },
  computed: {
    orderDeliveryMode(){
      return this.$store.getters.orderSystem.order.getDeliveryMode
    },
    localValue: {
      get() {
        return this.$store.getters.orderSystem.order.payment.method
      },
      set(val) {
        this.$store.commit('paymentMethod', val)
      }
    },
    getPaymentMethods() {
      return this.$store.getters.getPaymentMethods
    }
  },
  created() {
    if (this.getPaymentMethods === null) {
      this.$store.dispatch('findPaymentMethods')
    }
  },
}
</script>

<style scoped>

</style>
